var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import Box from './Box';
/**
 *
 * @param {object} props
 * @param {boolean | string} [props.flex]
 * @param {React.ReactNode} props.children
 */
export default function Col(_a) {
    var { flex } = _a, rest = __rest(_a, ["flex"]);
    return (_jsx(Box, Object.assign({ sx: {
            paddingX: 'columnGap',
            boxSizing: 'border-box',
            flex: flex === true ? '1' : flex,
        } }, rest)));
}
//# sourceMappingURL=Col.js.map